import { useEffect } from "react";
import { useFormikContext } from "formik";
import { useFormData } from "../../../contexts/FormData";

import styled from "@emotion/styled";

import { Grid, Divider, Paper } from "@mui/material";

import AutoCompleteSoloFormik from "../../../utils/FormikFields/AutoCompleteSolo";

import { InputLabel } from "../../../utils/Common";

import { displayInventoryItemLabel } from "../../../utils/displayLabels";

import SelectWigBrand from "./SelectWigBrand";
import Values from "../../InventoryItem/Components/Values";

const Pill = styled.div`
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 3px;
  padding: .5rem 1rem;
  font-size: 1.4rem;
  font-weight: 500;
  color: ${props => props.theme.colors.mildText};
`;

const SelectInventoryItem = () => {
  const { values, setValues } = useFormikContext();

  const { formValues, setFormValues } = useFormData() || {};

  useEffect(() => {
    if (values?.wig_type === "custom") {
      setFormValues(obj => {
        return {
          ...obj,
          inventory_item: null
        }
      });
    }
  }, [values.wig_type]);

  useEffect(() => {
    if (values?.inventory_id) return;
    let ii = formValues?.inventory_item || {};
    console.log(ii, "ii");
    setValues({...values,
      vendor_id: ii?.vendor_id?.toString(),
      brand_name: ii?.brand_name, 
      color: ii?.color,
      length: ii?.length,
      material: ii?.material,
      cap_size: ii?.cap_size,
      line: ii?.line,
      hairstyle: ii?.hairstyle,
      has_highlights: ii?.has_highlights,
      cost_subtotal: ii?.cost_subtotal || "",
      service_price: ii?.service_price || "",
      price: ii?.price || ""
    }, false);
  }, [formValues?.inventory_item, values?.inventory_id]);

  // if (values?.wig_type === "custom") return null;

  console.log(values, "values");

  return (
    <>
      <Grid size={{xs: 12}}>
        
        <InputLabel>Search Inventory Item</InputLabel>
        <AutoCompleteSoloFormik 
          name="inventory_item_id" 
          label="Search Inventory Item" 
          url="inventory_items" 
          fieldName="inventory_item_id" 
          displayField="sku" 
          displayLabel={displayInventoryItemLabel}
          saveOption={true}
          saveOptionField="inventory_item"
        />
        
          <Divider sx={{my: "2rem"}}><Pill>Or enter details manually</Pill></Divider>
          
          <Paper sx={{p: "1.6rem", backgroundColor: "background.faint"}} elevation={0}>
            <Grid container spacing={2}>
              <SelectWigBrand />
              <Values />
            </Grid>
          </Paper>
      </Grid>
    </>
  )
};

export default SelectInventoryItem;